import { Component } from '@mycolorway/tao';
import TextCell from './text-cell';
import 'next/stylesheets/components/grid/cells/number-cell.scss';

Component('tr-grid-number-cell', {
  extends: [TextCell],

  updateResult(content) {
    if (content) {
      this.result.num = content;
      this.result.format();
    } else {
      this.result.textContent = null;
    }
  },
});
